import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classNames from 'classnames';
import swal from 'sweetalert2';
import isEmpty from 'lodash/isEmpty';

import {copyTextToClipboard} from '../../../../../helpers/utils';
import selectEntities from '../../../../../selectors/entities';
import {fetchLeagueIfNeeded} from '../../../../../actions/app/support/league';

import './LeagueInfoWidget.css';
import Loader from '../../../../../components/Loader';
import LeagueInfos from './components/Infos';
import {getEndpoint, getHeaders} from '../../../../../helpers/endpoint';
import {getChampionships} from '../../../../../actions/entities/championships';

export const getDivisionInfos = payload => {
  return (_dispatch, getState) => {
    fetch(getEndpoint('getDivisionInfos', payload.divisionId), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          payload.onSuccess(data);
        }
      });
  };
};

export const getLeagueUsers = payload => {
  return (_dispatch, getState) => {
    fetch(getEndpoint('getLeagueUsers', payload.leagueId), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          payload.onSuccess(data);
        }
      });
  };
};

class LeagueInfoWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      leagueId: props.leagueId || '',
      selectedDivision: undefined,
      divisionInfos: undefined,
      divisionUsers: undefined,
    };
  }

  fetchLeagueInfo(e) {
    if (e) e.preventDefault();
    const {leagueId} = this.state;
    this.props.dispatch(
      getLeagueUsers({
        leagueId,
        onSuccess: leagueUsers => this.setState({leagueUsers}),
      }),
    );
    this.props.dispatch(fetchLeagueIfNeeded(leagueId));
    this.props.dispatch(getChampionships());
  }

  static copyToClipboard(email) {
    const success = copyTextToClipboard(email);
    success
      ? swal(`Copied!`, `${email} is in your clipboard.`, 'success')
      : swal(`Oops...`, `We couldn't copy ${email}`, 'error');
  }

  componentDidMount() {
    if (this.state.leagueId) {
      this.fetchLeagueInfo();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.selectedDivision !== this.state.selectedDivision &&
      this.state.selectedDivision !== undefined
    ) {
      this.props.dispatch(
        getDivisionInfos({
          divisionId: this.state.selectedDivision,
          onSuccess: divisionInfos => this.setState({divisionInfos}),
        }),
      );
    }
    if (
      prevProps.league.entity &&
      this.props.league.entity &&
      prevProps.league.entity.id !== this.props.league.entity.id
    ) {
      this.setState({
        selectedDivision: undefined,
        divisionInfos: undefined,
      });
    }
  }

  renderNoResult() {
    const {info} = this.props.widget;
    const {error} = info;

    return (
      <div className="no-result text-center">
        <h4 className="text-muted">Want to find a particular league ?</h4>
        <form className="form-inline" onSubmit={e => this.fetchLeagueInfo(e)}>
          <div
            className={classNames('form-group', {
              'has-error': error === 'leagueNotFound',
            })}>
            <div className="input-group input-group">
              <input
                type="text"
                className="form-control"
                placeholder="qFLv1HS36eh"
                value={this.state.leagueId}
                onChange={e => this.setState({leagueId: e.target.value.replace(/\s/g, '')})}
              />
              <span className="input-group-btn">
                <button
                  type="button"
                  className="btn btn-primary btn-flat"
                  onClick={this.fetchLeagueInfo.bind(this)}>
                  <i className="fa fa-search" />
                </button>
              </span>
            </div>
            {error === 'leagueNotFound' && (
              <span className="help-block">
                We couldn't find league {info.lastPayload.leagueId}
              </span>
            )}
          </div>
        </form>
      </div>
    );
  }

  renderBody() {
    const {league, dispatch, championship} = this.props;
    const {selectedDivision, divisionInfos, leagueUsers} = this.state;
    const {entity = {}} = league;

    if (isEmpty(entity)) return this.renderNoResult();

    const onSelectDivision = selectedDivision =>
      this.setState({selectedDivision});

    return (
      <div className="result">
        <LeagueInfos
          leagueUsers={leagueUsers}
          divisionInfos={divisionInfos}
          entity={entity}
          championship={championship}
          selectedDivision={selectedDivision}
          onSelectDivision={onSelectDivision}
          refreshDivisionInfos={() =>
            dispatch(
              getDivisionInfos({
                divisionId: this.state.selectedDivision,
                onSuccess: divisionInfos => this.setState({divisionInfos}),
              }),
            )
          }
        />
      </div>
    );
  }

  renderFooter() {
    const {entity} = this.props.league;

    return (
      entity && (
        <div className="box-footer form-inline">
          <form
            onSubmit={e => this.fetchLeagueInfo(e)}
            className="input-group margin-r-5 pull-right">
            <input
              type="text"
              className="form-control"
              placeholder="qqAAbGUlC9L"
              value={this.state.leagueId}
              onChange={e => this.setState({leagueId: e.target.value.replace(/\s/g, '')})}
            />
            <span className="input-group-btn">
              <button
                type="button"
                className="btn btn-default btn-flat"
                onClick={this.fetchLeagueInfo.bind(this)}>
                <i className="fa fa-search" />
              </button>
            </span>
          </form>
        </div>
      )
    );
  }

  render() {
    const {info} = this.props.widget;

    return (
      <div id="league-info-widget" className="row">
        <div className="col-md-12">
          <div className="box box-default">
            <div className="box-header with-border">
              <h3 className="box-title pull-left">
                <i className="fa fa-info-circle" /> League info
              </h3>
              <div className="box-tools pull-right">
                <button
                  type="button"
                  className="btn btn-box-tool"
                  data-widget="collapse">
                  <i className="fa fa-minus" />
                </button>
              </div>
            </div>
            <div className="box-body">{this.renderBody()}</div>
            {this.renderFooter()}
            {info.isFetching && <Loader />}
          </div>
        </div>
      </div>
    );
  }
}

LeagueInfoWidget.propTypes = {
  leagueId: PropTypes.string,
};

export default connect(
  state => {
    const {leagues} = state.entities;
    const {championships} = state.app;
    const widget = state.app.support.league;
    const entity = selectEntities(leagues, [widget.id])[0];

    return {
      widget,
      token: state.authentication.token,
      league: {entity: entity},
      championship:
        championships.list.data?.[entity?.gameSettings?.championshipId],
    };
  },
  dispatch => ({dispatch}),
)(LeagueInfoWidget);



// WEBPACK FOOTER //
// ./src/pages/Support/League/Widgets/LeagueInfo/index.js